module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      key: option.value
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": (_vm.name + "-" + (option.value)),
        "name": _vm.name
      },
      domProps: {
        "checked": _vm.value === option.value
      },
      on: {
        "input": function($event) {
          _vm.$emit('input', option.value);
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": (_vm.name + "-" + (option.value))
      }
    }, [_vm._v(_vm._s(option.label))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cabd2d5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/components/radio-group.vue
// module id = 3052
// module chunks = 0